import { render, staticRenderFns } from "./dealTitle.vue?vue&type=template&id=f3353c3e"
import script from "./dealTitle.vue?vue&type=script&lang=js"
export * from "./dealTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports